import DOMPurify from "dompurify";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { useTranslation } from "react-i18next";
// src/components/Slider/Slider.jsx
import { getSlidesConfig } from "../../config/slidesConfig"; // Goes up two levels from components/Slider
import { getSlideLayout } from "./layouts"; // Same directory
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Link } from "react-router-dom";

const Slider = () => {
  const { t } = useTranslation();
  const slides = getSlidesConfig(t);

  return (
    <div className="relative w-full" dir="ltr">
      <Swiper
        dir="ltr"
        spaceBetween={0}
        centeredSlides={true}
        autoplay={{ delay: 5000, disableOnInteraction: true }}
        pagination={{ clickable: true }}
        navigation={true} // Ensure navigation is enabled
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper" // Ensure the class is set for styling
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={slide.id}>
            <div className="relative w-full h-screen min-h-[500px]">
              {/* Responsive Background Image */}
              <div className="absolute inset-0 w-full h-full overflow-hidden">
                <picture>
                  {/* Mobile image (shows on screens < 768px) */}
                  <source
                    srcSet={slide.imageMUrl || slide.imageUrl}
                    media="(max-width: 767px)"
                  />
                  {/* Desktop image (shows on screens ≥ 768px) */}
                  <source srcSet={slide.imageUrl} media="(min-width: 768px)" />
                  {/* Fallback */}
                  <img
                    src={slide.imageUrl}
                    alt="Slide background"
                    className="w-full h-full object-cover"
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                </picture>
                <div
                  className={`absolute inset-0 ${
                    slide.overlay || "bg-black/20"
                  }`}
                />
              </div>

              {/* Content */}
              <div
                className={`relative z-10 ${getSlideLayout(slide)}`}
                dir="ltr"
              >
                {slide.content.title && (
                  <h1 className={slide.content.titleStyle}>
                    {slide.content.title}
                  </h1>
                )}
                {slide.content.subtitle && (
                  <p
                    className={`whitespace-pre-line ${slide.content.subtitleStyle}`}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(slide.content.subtitle || ""),
                    }}
                  />
                )}
                <div className="!flex items-center gap-4 md:!mt-6 !mt-2">
                  {slide.content.buttonText && (
                    <Link
                      to={slide.content.buttonLink}
                      className={`transition-all duration-300 hover:scale-105 ${slide.content.buttonStyle}`}
                    >
                      {slide.content.buttonText}
                    </Link>
                  )}
                  {slide.content.subtitleImage && (
                    <img
                      src={slide.content.subtitleImage}
                      alt="Fridge icon"
                      class="md:w-24 w-[3rem] h-12 object-contain"
                    />
                  )}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slider;
